import React from 'react';
import SignalCellularConnectedNoInternet0BarIcon from '@material-ui/icons/SignalCellularConnectedNoInternet0Bar';
import Typography from '@material-ui/core/Typography';

export const NullData = props => {
  return (
    <div
      style={{ width: '100%', padding: 20, textAlign: 'center', fontSize: 28 }}
    >
      <SignalCellularConnectedNoInternet0BarIcon style={{ fontSize: 50 }} />
      <Typography variant={'caption'}>Chưa có dữ liệu</Typography>
    </div>
  );
};

export const EmptyTable = () => {
  return (
    <div
      style={{
        height: '97%',
        width: '99%',
        border: '1.5px solid #e1e3e6cc',
        borderRadius: '4px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        fontSize: '14px'
      }}
    >
      <img
        src="/static/empty.png"
        style={{ width: '200px' }}
      />
      <span> Danh sách trống </span>
    </div>
  );
};
